import { F0Box, F0Button, F0Heading, F0OneIcon, F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { useOpenDashboardAction } from 'modules/ai/copilotActions/canvas/dashboards/useOpenDashboardAction'

// NOTE: `discover.mp4` is placed by the user at this path. Missing it will
// only fail at bundle time (vite); `tsc` is happy because `vite/client`
// types cover the import.
import discoverVideo from 'modules/ai_reports/pages/DiscoverPage/assets/discover.mp4'

const DiscoverBanner = () => {
  const { openChatForNewDashboard } = useOpenDashboardAction()

  return (
    <F0Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap="2xl"
      borderRadius="lg"
      border="default"
      borderColor="secondary"
    >
      <F0Box display="flex" flexDirection="column" gap="md" grow padding="2xl">
        <F0OneIcon size="lg" />
        <F0Heading variant="heading-large" content={i18n.t('ai_reports.discover.banner.title')} />
        <F0Text variant="body" content={i18n.t('ai_reports.discover.banner.description')} />
        <F0Box marginTop="lg">
          <F0Button
            variant="ai"
            label={i18n.t('ai_reports.dashboards.create_report')}
            onClick={openChatForNewDashboard}
          />
        </F0Box>
      </F0Box>
      <F0Box grow>
        {/* TODO: ~5MB asset bundled in git — migrate to CDN or re-encode (WebM)
            in a follow-up. preload="metadata" is a hint that's largely ignored
            with autoPlay, but kept for parity with non-autoplay paths. */}
        <video
          src={discoverVideo}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          style={{ width: '100%', borderRadius: 12, display: 'block' }}
        />
      </F0Box>
    </F0Box>
  )
}

export default DiscoverBanner
